import React, { FC } from 'react';
import { Breadcrumb, Icon } from '@firesoon/antd';
import { HomeMenu } from '@firesoon/icons-react';
import { BreadcrumbProp, Path } from './interface';
import './index.less';

const Index: FC<BreadcrumbProp> = ({
  pathList = [],
  onLink,
  home = 'home',
  className = '',
  bordered = true,
}) => {
  return (
    // 只有首页时显示图标 + 首页， 否则不显示首页俩字
    <Breadcrumb
      separator={<Icon type="right" />}
      className={`fs-breadcrumb ${className}${bordered ? ' fs-breadcrumb-bordered' : ''}`}
    >
      {pathList.map((path: Path, index) => (
        <Breadcrumb.Item key={path.id}>
          {path.clickable ?
            <a onClick={() => index < pathList.length - 1 && onLink(path.id, path, index)}>
              {path.id === home && <HomeMenu style={{ fontSize: 16 }} />}
              {path.id === home && pathList.length === 1 &&
                <span style={{ marginLeft: 4 }}>{path.title}</span>
              }
              {path.id !== home && <span>{path.title}</span>}
            </a> :
            path.title
          }
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Index;